import React from "react";
import { CircleWithBadge } from "../../../advancing/components";

interface Props {
  amountApprovedResponses: number
}

const ApprovedBadge = (props: Props) => {
  const { amountApprovedResponses } = props;
  const title = (amountApprovedResponses === 1) ? `1 ${RESX.Advancing.itemApproved}` : amountApprovedResponses + " " + RESX.Advancing.itemsApproved;
  return <CircleWithBadge icon="checked" count={amountApprovedResponses} title={title} />;
};

export default ApprovedBadge;